import React from "react";
import { CircularProgress, Dialog, DialogContent } from "@mui/material";
//Import Breadcrumb

const LoadingDialog = ({ open, message }) => {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                PaperProps={{ sx: { padding: 1 } }}
            >
                <DialogContent style={{ color: 'var(--bs-theme-color)', display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", flexDirection: "column" }}>
                    <CircularProgress color="inherit" />
                    <span>{message}</span>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default LoadingDialog;
